export default __webpack_public_path__ + "images/value_tags/cruelty_free-c2e9c18e14a1de81d97a516b55e45094.svg";